import { useCallback, useContext } from "react";
import Socket, { generateRoomId } from "../providers/Socket";
let timer = 1000;
const useMain = () => {
    const { socket } = useContext(Socket);
    const CreateRoomHandler = useCallback(function (config) {
        if (config.ownerId === config.userId)
            throw new Error("Invalid Config");
        const roomId = generateRoomId(config.postId, config.ownerId, config.userId);
        const currentTime = (new Date).getTime();
        return {
            oid: config.ownerId,
            pid: config.postId,
            post_country: config.post_country,
            post_img: config.post_img,
            post_title: config.post_title,
            unread: 0,
            rooms: [
                {
                    room: roomId,
                    uid: config.userId,
                    name: config.room.name,
                    avatar: config.room.avatar,
                    last_time: currentTime,
                    unread: 0
                }
            ],
        };
    }, [socket]);
    return {
        getUnreadPostRooms: useCallback((postId) => {
            return new Promise((resolve, reject) => {
                console.log(socket, 'socket');
                if (!socket)
                    resolve(0);
                socket === null || socket === void 0 ? void 0 : socket.emit('my-post-unread-rooms', { pid: postId }, function ({ result }) {
                    resolve(result);
                });
            });
        }, [socket]),
        getBlockedUsers: useCallback(() => {
            return new Promise((resolve, reject) => {
                if (!socket)
                    resolve([]);
                socket === null || socket === void 0 ? void 0 : socket.emit('get-blocked', function (result) {
                    resolve(result);
                });
            });
        }, [socket]),
        createRoom: useCallback((config) => new Promise((resolve, reject) => {
            const intervalHandler = () => {
                const room = CreateRoomHandler(config);
                if (room) {
                    resolve(room);
                    clearInterval(interval);
                    return;
                }
                timer += 1000;
                if (timer > 10000) {
                    reject("Time Out");
                    clearInterval(interval);
                }
                return;
            };
            const interval = setInterval(intervalHandler, timer);
        }), [CreateRoomHandler])
    };
};
export default useMain;
